import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import ShieldIcon from '@mui/icons-material/Shield';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
export function GuaranteeSection() {
  const checks = ['Devolución del 100%', 'Sin formularios', 'Sin drama', 'Sin preguntas'];
  return <SectionWrapper className="bg-primary text-white py-20" data-id="element-106">
      <div className="max-w-3xl mx-auto text-center" data-id="element-107">
        <ShieldIcon sx={{
        fontSize: 80
      }} className="text-amber-400 mb-6" data-id="element-108" />
        <h2 className="font-serif text-3xl md:text-5xl font-bold mb-6" data-id="element-109">
          GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>

        <div className="text-lg md:text-xl font-medium mb-8 text-primary-dark bg-white/10 py-4 px-6 rounded-xl inline-block" data-id="element-110">
          <p data-id="element-111">Abrís el kit. Empezás el protocolo.</p>
          <p data-id="element-112">Si en 7 días no es lo que esperabas:</p>
        </div>

        <div className="bg-white text-gray-900 rounded-2xl p-8 max-w-xl mx-auto shadow-2xl mb-8" data-id="element-113">
          <h3 className="font-bold text-gray-500 uppercase tracking-wider text-sm mb-4 border-b pb-2" data-id="element-114">
            Compromiso
          </h3>
          <ul className="space-y-4 text-left" data-id="element-115">
            {checks.map((check, i) => <li key={i} className="flex items-center text-lg font-medium" data-id="element-116">
                <CheckCircleIcon className="text-green-500 mr-3" data-id="element-117" />
                {check}
              </li>)}
          </ul>
        </div>

        <p className="text-amber-400 font-bold text-lg" data-id="element-118">
          Tasa de devoluciones: menos del 1%.
        </p>
      </div>
    </SectionWrapper>;
}